import { render, staticRenderFns } from "./riepilogo.vue?vue&type=template&id=2f75c272"
import script from "./riepilogo.vue?vue&type=script&lang=js"
export * from "./riepilogo.vue?vue&type=script&lang=js"
import style0 from "./riepilogo.vue?vue&type=style&index=0&id=2f75c272&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports